module.exports = __webpack_public_path__ + "static/media/fluid-blue.7dfa3567.png";